import React, {useState, useRef, useEffect} from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import {Link, useHistory} from 'react-router-dom';
import { Form } from '@unform/web';

import BoxSocial from '../../components/Form/BoxSocial';
import CustomButton from '../../components/Form/Button';
import Input from '../../components/Form/Input';

import { register } from '../../services/Auth';

import {IconButton, InputAdornment} from "@material-ui/core";
import {
  Container,
  HeaderGradient,
  LogoWrapper,
  HeroTagline,
  Subtitle,
  Card,
  Title,
  FormWrapper,
  Divider,
  FooterLink,
  CopyrightWrapper,
} from "../SignIn/styles";
import {isMobile} from "react-device-detect";
import logo from "../../assets/img/logo.png";
import Copyright from "../../components/Copyright";
import {useTranslation} from "react-i18next";
import {Visibility, VisibilityOff} from "@material-ui/icons";

function SignUp(props) {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const history = useHistory();
  const [isRedirectMobile, setRedirectMobile] = useState(false);
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    setRedirectMobile(props.location.state && props.location.state.params && props.location.state.params.isRedirectMobile);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const aff = params.get('aff');
    if (aff) {
      sessionStorage.setItem('affiliateID', aff);
    }
  }, []);

  async function handleRegister(data) {
    if (loading) {
      return;
    }
    setLoading(true);
    try {
      formRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required(t('blank_name')),
        email: Yup.string()
            .email(t('email_invalid'))
            .required(t('blank_email')),
        password: Yup.string().required(t('blank_password'))
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      const formData = new FormData();
      formData.append('name', data.name);
      formData.append('username', data.email);
      formData.append('password', data.password);
      const affiliateID = sessionStorage.getItem('affiliateID');
      if (affiliateID && affiliateID !== '') {
        formData.append('affiliateID', affiliateID);
      }
      const response = await register(formData);

      if (response && response.status === 200) {
        if (isRedirectMobile && isMobile) {
          window.ReactNativeWebView.postMessage('{"name": "'+data.email+'", "user_token" : "'+response.data.token+'"}');
          return;
        }

        localStorage.setItem('@name', response.data.name);
        localStorage.setItem('userKey', data.email);
        localStorage.setItem('@user_token', response.data.token);
        toast.success(t('register_success'));
        history.push('/dashboard');
      } else {
        toast.error(t('register_error'));
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      toast.error(t('register_error'));
      setLoading(false);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message;
        });
        formRef.current.setErrors(validationErrors);
      }
    }
  }

  return (
      <>
        <Container>
          <HeaderGradient>
            <LogoWrapper>
              <Link to={"/"}>
                <img
                    alt={"Logo GBinary"}
                    src={logo}
                />
              </Link>
            </LogoWrapper>
            <HeroTagline>{t('login_title')}</HeroTagline>
          </HeaderGradient>

          <Card>
            <Title>{t('login_create_account')}</Title>
            <Subtitle>{t('register_subtitle')}</Subtitle>
            <FormWrapper>
              <Form ref={formRef} onSubmit={handleRegister}>
                <Input
                    type="text"
                    name="name"
                    autoComplete="name"
                    placeholder={t('placeholder_name')}
                    label={t('login_label_input_user_name')}
                />

                <Input
                    type="text"
                    name="email"
                    autoComplete="email"
                    placeholder={t('placeholder_email')}
                    label={t('login_label_input_user_email')}
                />

                <Input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    autoComplete="new-password"
                    placeholder={t('placeholder_password')}
                    label={t('login_label_input_user_password')}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          onMouseUp={handleMouseUpPassword}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff/> : <Visibility/>}
                        </IconButton>
                      </InputAdornment>,
                    }}
                />

                <CustomButton
                  className="signin-submit"
                  loading={loading}
                  type="submit"
                >
                  {t('login_btn_register')}
                </CustomButton>
              </Form>

              <Divider>{t('login_label_login_google')}</Divider>
              <BoxSocial/>
            </FormWrapper>

            <FooterLink>
              {t('login_account_exists')}{' '}
              <a href={isRedirectMobile === 'true' ? '/?isRedirectMobile=true' : '/login'}>
                {t('login_account_exists_1')}
              </a>
            </FooterLink>
          </Card>

          <CopyrightWrapper>
            <Copyright/>
          </CopyrightWrapper>
        </Container>
      </>
  );
}

export default SignUp;
